import * as types from './types'

export const actions = {
	toggleLoading: (payload) => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: (payload) => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	toggleError: (payload) => ({
		type: types.TOGGLE_ERROR,
		payload,
	}),

	setQR: (payload) => ({
		type: types.SET_QR,
		payload,
	}),
	setQRKey: (payload) => ({
		type: types.SET_QR_KEY,
		payload,
	}),
	getQRStatus: (payload) => ({
		type: types.GET_QR_STATUS,
		payload,
	}),
	resetVerification: () => ({
		type: types.RESET_VERIFICATION,
	}),


	setIinPhone: (payload) => ({
		type: types.SET_SMS_IIN_PHONE,
		payload,
	}),
	setIinPhoneDone: (payload) => ({
		type: types.SET_SMS_IIN_PHONE_DONE,
		payload,
	}),
	setIinPhoneFail: () => ({
		type: types.SET_SMS_IIN_PHONE_FAIL,
	}),


	setSms: (payload) => ({
		type: types.SET_SMS_SEND,
		payload,
	}),
	setSmsDone: (payload) => ({
		type: types.SET_SMS_SEND_DONE,
		payload,
	}),
	setSmsFail: () => ({
		type: types.SET_SMS_SEND_FAIL,
	}),

	setStepName: (payload) => ({
		type: types.STEP_NAME,
		payload,
	}),
}
